import * as React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"


export default function AvailableButton({ status, label, onClick=null }) {
    const icon = status ? "check-to-slot" : "xmark-to-slot"
    const color = status ? "success.main" : "error.main"

    return <Box>
        <ButtonIconSeeker
            icon={icon}
            iconProps={{ color }}
            onClick={onClick}
        /> {label}
    </Box>
}